import React, { Component } from 'react'
import 'less/input.less'

class Input extends Component {

  state = {
    focused: false
  }

  render() {
    const showError = !this.state.focused && this.props.showErrors && this.props.error
    return (
      <div className={`bp3-form-group ${showError ? `bp3-intent-danger ${this.props.className}` : ` ${this.props.className}`}`}>
        {this.props.title &&
          <label className={`bp3-label ${this.props.description ? 'with-desc' : ''}`}>{this.props.title}
            {this.props.description && <i className="bp3-label description"> {this.props.description}</i>}
          </label>} 
        <div className="bp3-form-content">
          <div className={`bp3-input-container`}>
            <input
              type={this.props.inputType || "text"}
              className="project-input"
              placeholder={this.props.placeholder}
              dir="auto"
              value={this.props.value}
              disabled={this.props.disabled}
              onChange={this.props.onChange}
              onBlur={(e) => {
                this.props.onBlur && this.props.onBlur(e)
                this.setState({ focused: false })
              }}
              onFocus={(e) => {
                this.props.onFocus && this.props.onFocus(e)
                this.setState({ focused: true })
              }}
              name={this.props.name}
            />
            {!this.props.error && this.props.touched &&  <i className="im-checkmark3"/>}
          </div>
          {showError && <div className="bp3-form-helper-text">{this.props.error}</div>}
        </div>
      </div>
    )
  }
}

export default Input
